<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="aboutData">
    <div v-if="aboutData.code === 500 || aboutData.length === 0" class="cms-error">
      <span>{{ $t('not_cms') }}</span>
    </div>
    <div v-else class="about-page has-side-bars">
      <h2 class="about-title" v-html="aboutData[0].title" />
      <div v-cms="aboutData[0].htmldefinition" class="about-def" />
    </div>
  </div>
  <div v-else class="loader">
    <Loader :text="$t('loading')" />
  </div>
</template>

<script>
import { vCmsHtml as cms, getCMSWebpages } from '@/services/graphql'
import Loader from '../components/Loader.vue'

export default {
  components: { Loader },
  directives: { cms },
  props: {},
  metaInfo (){
    return {
      title: 'About | '+this.$t('cover_title'),
      meta: [
        {
          name: 'title',
          content: 'About | '+this.$t('cover_title')
        }
      ]
    }
  },
  asyncComputed: {
    aboutData() {
      return getCMSWebpages(this.$store.state.i18n.lang, 'about')
    },
  },
}
</script>

<style lang="stylus" scoped>
.about-page
  display: flex
  flex-direction: column
  margin-top: vw(30px)
  margin-bottom: vw(20px)
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))
  gap: vw(6px)

  .about-title
    m-font-size(30, 34)
    color: black
    font-weight: 600
    margin-block-start: 0
    margin-block-end: 0

  .about-def
    m-font-size(16, 24)
    color: $grey-dark
    margin-right: 170px 
    
    .mobile &
      margin-right: 0px 

    >>> .anchor
      position: relative
      top: vw(-80px)
    
    >>> .index
      position: sticky
      margin-left: 'calc(100% + %s)' % vw(20px)
      top: "calc(%s + %s + %s)" % ($header-height $subheader-height vw(10px))
      width: 158px
      height: 0
      display: flex
      flex-direction: column
      gap: vw(10px)
      
      .mobile &
        position: inherit
        height: auto
        margin-left: 0
        width: 100%
      
      .desc-wrap
        display: flex
        flex-direction: column
        margin-bottom: vw(15px)
      
        .title
          color: black
          m-font-size(18, 26)
          font-weight: 600
        
        .desc
          color: black
          m-font-size(14, 22)
          font-weight: 300
      
      .link
        color: $corporate_color
        m-font-size(14, 22)
        font-weight: 400
        
        &::before 
          content: "- "
          color: $corporate_color
          
        &.link-2
          margin-left: vw(15px)
          
        &.link-3
          margin-left: vw(30px)

    >>> a
      color: $corporate_color
      text-decoration: none

      &:hover
        color: $corporate_color
        text-decoration: underline
        cursor: pointer

    >>> li
      margin-left: vw(20px)
      padding: 0
      list-style-type: disc

.cms-error
  display: flex
  justify-content: center
  align-items: center
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))

  span
    m-font-size(20, 26)
    color: black
    font-weight: 400
    
.loader
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))
</style>
